import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DialogService } from '../../dialog/shared/dialog.service'

import { ImageCropperComponent, CropperSettings } from 'ng2-img-cropper'

@Component({
  moduleId: module.id,
  selector: 'cm-profile-image',
  templateUrl: 'profile-image.component.html',
  styleUrls: ['profile-image.component.css']
})
export class ProfileImageComponent implements OnInit {
  @Input() image: string
  @Input() isRemovable: boolean

  @Output() imageChange = new EventEmitter<string>()
  @Output() imageRemove = new EventEmitter<any>()

  @ViewChild('file') file: ElementRef

  public data = {}

  constructor(private dialogService: DialogService) {
  }

  ngOnInit() {

  }

  chooseFile() {
    this.file.nativeElement.click()
  }

  crop(event: any) {
    const files: FileList = event.target.files
    if (files[0]) {
      const image: File = files[0]
      this.dialogService.crop('Redimensionnement', image)
        .subscribe((result: any) => {
          this.imageChange.emit(result)
        })
    }
  }

  remove() {
    this.imageRemove.emit()
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/profile-image/profile-image.component.ts